import { useEffect } from 'react';
import { useMissions } from '@/hooks/useMissions';

interface GameMissionTrackerProps {
  gameId: string;
  gameTitle: string;
}

export function GameMissionTracker({ gameId, gameTitle }: GameMissionTrackerProps) {
  const { handleVisitGamePage, handleAddFavorite, handleLikeGame } = useMissions();

  useEffect(() => {
    // Marquer la visite de la page de jeu comme mission complétée
    handleVisitGamePage(gameId);
  }, [gameId, handleVisitGamePage]);

  // Les autres actions (like, favorite) seront déclenchées par les composants correspondants
  // Ce composant sert principalement à tracker la visite de la page

  return null; // Ce composant n'affiche rien, il ne fait que tracker
}

// Hook pour les actions de jeu
export function useGameActions(gameId: string) {
  const { handleLikeGame, handleAddFavorite } = useMissions();

  const handleLike = () => {
    handleLikeGame(gameId);
  };

  const handleFavorite = () => {
    handleAddFavorite(gameId);
  };

  return {
    handleLike,
    handleFavorite
  };
}
